import {
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Toolbar,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { formatDate, formatDateTime } from "../../util";

import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import MaterialTable from "material-table";
import { stylesMain } from "../../css";
import { useGetStudents } from "../../fetch/student";
import useUserStateContext from "../../userstate";
import { withRouter } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";

const Student = (props: any) => {
  const { classes } = props;
  const { userState } = useUserStateContext();
  const { students, getStudents } = useGetStudents();
  const [snackBarOpen, setSnackBarOpen] = useState(false);

  useEffect(() => {
    userState.signedIn === false && props.history.push("/login");
    getStudents({});
  }, [userState, props.history]);

  const copyStudentId = (event: React.MouseEvent, id: string) => {
    // 行クリックによる詳細画面への遷移を抑止してコピーのみ行う
    event.stopPropagation();
    navigator.clipboard.writeText(id);
    setSnackBarOpen(true);
  };

  return (
    <Fragment>
      <main className={classes.main}>
        <Toolbar>
          <Grid justify="space-between" container>
            <Grid item>
              <Typography component="h1" variant="h6">
                Student
              </Typography>
            </Grid>
          </Grid>
        </Toolbar>
        <Divider />
        <div className={classes.table}>
          <MaterialTable
            columns={[
              {
                title: "Student ID",
                field: "id",
                render: (rowData: any) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>{rowData.id}</span>
                    <Tooltip title="IDをコピー">
                      <IconButton
                        size="small"
                        style={{ marginLeft: 4 }}
                        onClick={(event) => copyStudentId(event, rowData.id)}
                      >
                        <FileCopyOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                ),
              },
              {
                title: "Name",
                field: "full_name",
              },
              {
                title: "Name Kana",
                field: "full_name_kana",
              },

              { title: "E-mail", field: "email" },
              { title: "Gender", field: "gender" },
              {
                title: "Birth Date",
                field: "birth_date",
                type: "datetime",
                render: (rowData: any) => {
                  return (
                    rowData.birth_date &&
                    formatDate(new Date(rowData.birth_date))
                  );
                },
              },
              { title: "Tel Mobile Phone", field: "tel_mobile_phone" },
              { title: "Name Emergency", field: "name_emergency" },
              { title: "Tel Emergency", field: "tel_emergency" },
              { title: "Postcode", field: "postcode" },
              { title: "Address", field: "address" },
              { title: "Company Name", field: "company.name" },
              { title: "Company Tel", field: "company.tel" },
              { title: "Company Address", field: "company.address" },
            ]}
            data={students && students}
            options={{
              headerStyle: {
                backgroundColor: "#fafafa",
              },
              showTitle: false,
              pageSize: 40,
              pageSizeOptions: [20, 40, 60, 5000],
              searchFieldAlignment: "left",
              emptyRowsWhenPaging: false,
              exportButton: true,
              exportFileName: `S2M Student List_${formatDateTime(new Date())}`,
              toolbarButtonAlignment: "left",
              filtering: true,
            }}
            components={{
              Container: Fragment,
            }}
            onRowClick={(event, rowData: any) => {
              rowData &&
                props.history.push({
                  pathname: `/student/${rowData.id}`,
                  state: { student: rowData },
                });
            }}
          />
        </div>
      </main>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={snackBarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackBarOpen(false)}
        message="Student ID をコピーしました"
      />
    </Fragment>
  );
};

export default withStyles(stylesMain)(withRouter(Student));
